// Pure decision logic for SmartRootIndex. Extracted so it can be unit-tested
// without needing a React renderer or browser.

export const LAST_PATH_KEY = "lastUserPath";
export const LAST_PATH_TTL_MS = 24 * 60 * 60 * 1000;
export const RETURN_URL_KEY = "metamaskReturnUrl";
export const RETURN_URL_TTL_MS = 5 * 60 * 1000;
export const DEFAULT_FALLBACK = "/auth/login";

const tryParse = (raw) => {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

// storageGet: (key) => string|null   (e.g. (k) => localStorage.getItem(k))
// storageRemove: (key) => void       (e.g. (k) => localStorage.removeItem(k))
// now: number (ms since epoch)
export const decideRootRedirect = (
  storageGet,
  storageRemove = () => {},
  now = Date.now()
) => {
  const returnUrlRaw = tryParse(storageGet(RETURN_URL_KEY));
  if (returnUrlRaw) {
    const fresh = now - (returnUrlRaw.timestamp || 0) < RETURN_URL_TTL_MS;
    if (!fresh) {
      storageRemove(RETURN_URL_KEY);
    } else if (
      returnUrlRaw.url &&
      returnUrlRaw.url !== "/" &&
      returnUrlRaw.url !== ""
    ) {
      return returnUrlRaw.url;
    }
  }

  const lastPathRaw = tryParse(storageGet(LAST_PATH_KEY));
  if (lastPathRaw) {
    const fresh = now - (lastPathRaw.timestamp || 0) < LAST_PATH_TTL_MS;
    if (!fresh) {
      storageRemove(LAST_PATH_KEY);
    } else if (
      lastPathRaw.path &&
      lastPathRaw.path.startsWith("/user/") &&
      lastPathRaw.path !== "/user/" &&
      lastPathRaw.path !== "/user"
    ) {
      return lastPathRaw.path;
    }
  }

  return DEFAULT_FALLBACK;
};
